module.exports = __webpack_public_path__ + "static/media/restaurants (2).895fb418.jpg";